import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { UserServices } from "$services";
import { CacheInvalidationAction } from "$utils/cache";
import useAuth from "./useAuth";
import { User } from "$types/User";

export const useUsersQuery = (filters: any = {}, enabled = true) => {
  const { token } = useAuth();
  return useQuery<User[]>({
    queryKey: [CacheInvalidationAction.GET_USERS, filters],
    queryFn: () => UserServices.FetchUsers(token, filters),
    enabled: !!token && enabled,
    staleTime: 5 * 60 * 1000,
  });
};

export const useAddUserMutation = () => {
  const queryClient = useQueryClient();
  const { token } = useAuth();

  return useMutation({
    mutationFn: (data: any) => UserServices.AddUsers(token, data),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CacheInvalidationAction.GET_USERS],
      });
    },
  });
};

export const useEditUserMutation = (userId?: string) => {
  const queryClient = useQueryClient();
  const { token } = useAuth();

  return useMutation({
    mutationFn: (data: any) =>
      UserServices.EditUsers(token, data.data, userId || data.userId),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CacheInvalidationAction.GET_USERS],
      });
      if (userId) {
        queryClient.invalidateQueries({
          queryKey: [CacheInvalidationAction.GET_USER_BY_ID, userId],
        });
      }
    },
  });
};

export const useDeleteUserMutation = () => {
  const queryClient = useQueryClient();
  const { token } = useAuth();

  return useMutation({
    mutationFn: (userId: string) => UserServices.DeleteUser(token, userId),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CacheInvalidationAction.GET_USERS],
      });
    },
  });
};
